"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = calculate;
require("core-js/modules/es.date.to-string.js");
var _types = require("./types");
var MONTH_ARRAY = [_types.Month.JANUARY, _types.Month.FEBRUARY, _types.Month.MARCH, _types.Month.APRIL, _types.Month.MAY, _types.Month.JUNE, _types.Month.JULY, _types.Month.AUGUST, _types.Month.SEPTEMBER, _types.Month.OCTOBER, _types.Month.NOVEMBER, _types.Month.DECEMBER];
function calculate(tenantStatus, monthlyRent, moveDate) {
  // increment month, because day 0 takes you to the last day of the previous month
  var daysInMonth = new Date(moveDate.getFullYear(), moveDate.getMonth() + 1, 0).getDate();
  var proratedRentPeriodStart;
  var proratedRentPeriodEnd;
  if (tenantStatus === _types.TenantStatus.MOVE_IN) {
    proratedRentPeriodStart = moveDate;
    var endOfMonth = new Date(moveDate.getFullYear(), moveDate.getMonth() + 1, 0);
    proratedRentPeriodEnd = endOfMonth;
  } else {
    var startOfMonth = new Date(moveDate.getFullYear(), moveDate.getMonth(), 1);
    proratedRentPeriodStart = startOfMonth;
    proratedRentPeriodEnd = moveDate;
  }
  return {
    dailyRent: monthlyRent / daysInMonth,
    days: proratedRentPeriodEnd.getDate() - proratedRentPeriodStart.getDate() + 1,
    // include both start and end date
    month: MONTH_ARRAY[moveDate.getMonth()]
  };
}